import { fromLocalStorage } from "io/localStorage";
import { getAheadTurns } from "lib/getAheadTurns";
import { getWait } from "network/requests";
//import { getWaitStimated } from "lib/getWaitStimated";
import { path, pathOr } from "ramda";
import { selectUserTicketByLine } from "state/tickets/selectors";
import { useEffect, useGlobal, useState } from "reactn";
import moment from "moment";

export const useTimeAndPeopleAhead = (line, office, qrTicket) => {
	const [loading, setLoading] = useState(null);
	const [tickets] = useGlobal("ticketsv2");

	const [wait, setWait] = useState("-");
	const [attentionList, setAttentionList] = useState([]);
	let userData = fromLocalStorage().user;
	const ticket = selectUserTicketByLine(tickets, line ? line.slug : "");
	const waiting = pathOr(0, ["waiting"], line);
	const webWaiting = pathOr(0, ["raw_tickets", "queue"], line);
	const lineWait = pathOr(0, ["wait"], line);
	const isFrozen = pathOr(false, ["frozen"], line);
	const call = pathOr(0, ["call", "number"], line);
	const webOnly = pathOr(false, ["options", "web_only"], office);
	const globalWaiting = webOnly ? webWaiting : waiting;
	const [peopleAhead, setPeopleAhead] = useState(globalWaiting);
	//const avgElapsed = pathOr(0, ["raw_tickets", "avg_elapsed", "mean"], line);

	const realPeopleAhead = ticket
		? globalWaiting > 0
			? globalWaiting - 1
			: "-"
		: line && globalWaiting;

	useEffect(() => {
		if (attentionList.length && ticket) {
			if (ticket && line) {
				let ahead = getAheadTurns(
					parseInt(ticket.number),
					parseInt(line?.call?.number)
				);
				return setPeopleAhead(ahead);
			}
		}

		return;
	}, [attentionList, line]);

	useEffect(() => {
		if (line && line.attention) setAttentionList(line.attention);
	}, [line, globalWaiting]);

	useEffect(() => {
		if (isFrozen) return;
		if (globalWaiting >= 0 && qrTicket && line && office) {
			setLoading(true);
			let body = {
				slug: typeof office === "object" ? office.slug : office,
				line: line && line.slug,
				ticket: true,
				ticket_number: qrTicket.number,
				ticket_arrival: qrTicket.inserted_at,
			};
			getWait(userData.token, body)
				.then((res) => {
					let wait = res.data.wait;
					let trained = res.data.trained;
					if (trained === true) {
						setLoading(false);
						return setWait(Math.ceil(wait / 60));
					} else if (trained === false) {
						setLoading(false);
						return false;
					}
				})
				.catch((err) => {
					setLoading(false);
					return false;
				});
		}

		if (!qrTicket && globalWaiting >= 0 && ticket && line && office) {
			setLoading(true);
			let body = {
				slug: typeof office === "object" ? office.slug : office,
				line: line && line.slug,
				ticket: true,
				ticket_number: ticket.number,
				ticket_arrival: ticket.inserted_at,
			};
			getWait(userData.token, body)
				.then((res) => {
					let wait = res.data.wait;
					let trained = res.data.trained;
					if (trained === true) {
						setLoading(false);
						return setWait(Math.ceil(wait / 60));
					} else if (trained === false) {
						setLoading(false);
						return false;
					}
				})
				.catch((err) => {
					setLoading(false);
					return false;
				});
		}

		if (globalWaiting >= 0 && !ticket && !qrTicket && line && office) {
			setLoading(true);
			let body = {
				slug: typeof office === "object" ? office.slug : office,
				line: line && line.slug,
				ticket: false,
				ticket_number: call + globalWaiting + 1,
				ticket_arrival: moment().toISOString(),
			};
			getWait(userData.token, body)
				.then((res) => {
					let wait = res.data.wait;
					let trained = res.data.trained;
					if (trained === true) {
						setLoading(false);
						return setWait(Math.ceil(wait / 60));
					} else if (trained === false) {
						setLoading(false);
						return false;
					}
				})
				.catch((err) => {
					setLoading(false);
					return false;
				});
		}
	}, [globalWaiting, office]);

	return { realPeopleAhead, wait, loading, peopleAhead: globalWaiting };
};
